export default __webpack_public_path__ + "static/media/icon-favourite.936deab8.svg";